export default __webpack_public_path__ + "static/media/0327.cac91ace.jpg";